module.exports = __webpack_public_path__ + "static/media/hands_19.49d2d584.svg";